import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7be3d19e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be3d19e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7be3d19e')) {
      api.createRecord('7be3d19e', component.options)
    } else {
      api.reload('7be3d19e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7be3d19e&scoped=true", function () {
      api.rerender('7be3d19e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mall/index.vue"
export default component.exports